<div class="error-page">
    <form>
        <div class="container">
            <div class="text-center">
                <h2>{{ _translateService.Keys.ERROR_SERVER_ERROR | translate }}</h2>
            </div>            
        </div>
    </form>
</div>